// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1_RNG","cls2":"FeedbackModal-cls2_NrT FeedbackModal-cls1_RNG"};